import React, { Component } from 'react';
import { Row, Col, Tabs } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../../store/actions';
import { showModal } from '../../store/actions/AssessmentActions';
import DriverCodeModal from '../../components/DriverCodeModal';
import {
  currProblemSelector,
  activeTemplateSelector,
  activeTabSelector,
  languageListSelector,
  selectedTab,
  attemptedCountSelector,
} from '../../store/reducers/AssessmentReducer';
import { withRouter } from 'react-router-dom';
import ProblemDescription from '../../components/Problem/ProblemDescription';
import TestCase from '../../components/Problem/TestCase';
import OutPut from '../../components/Problem/OutPut';
import Editor from '../../components/Editor/Editor';
import ProblemSelector from '../../components/Problem/ProblemSelector';
import ProblemNavigation from '../../components/Problem/ProblemNavigation';
import { history } from '../../index';
import BackButton from '../../assets/images/back_button.png';
import { handleGAEvent } from '../../helperFunctions';
import { GACategories, GAActions } from '../../analytics';
import {
  switchToNextSection,
  showLastSectionCompletionModal,
  updateSectionRoute,
} from '../../Utils/sectionUtils';
import { TRIGGER_BY_USER } from '../../const';

// Import scss file as a module
import styles from './ProblemContainer.scss';
import ProblemSidePanel from '../../components/ProblemSidePanel/ProblemSidePanel';
import { RightOutlined } from '@ant-design/icons';

class ProblemContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assessment_id: this.props.match.params.assessment_id,
      problem_id: this.props.match.params.problem_id,
      code: this.props.code,
      editorExpand: false,
      stdin: '',
      submit_disabled: false,
      isSidePannelOpen: true,
      showDriverCodeModal: false,
      theme: 'vs-light',
    };
  }

  componentDidMount() {
    this.props.setCurrentPage('QP');
    this.props.fetchAssessment(this.state.assessment_id, this.state.problem_id);
    if (!sessionStorage.getItem('assessment_id')) {
      sessionStorage.setItem('assessment_id', this.state.assessment_id);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.assessment.sections &&
      this.props.assessment.sections.length > 0 &&
      this.props.currentSectionId === null &&
      (prevProps.assessment.sections !== this.props.assessment.sections ||
        prevProps.currentSectionId !== this.props.currentSectionId)
    ) {
      const section = this.props.assessment.sections.find(section => {
        const sectionProblems = this.props.sectionProblems[section.id] || [];
        return sectionProblems.some(problem => problem.id === this.state.problem_id);
      });
      if (section) {
        this.props.setCurrentSectionId(section.id);
      }
    }
  }

  componentWillReceiveProps = nextProps => {
    if (this.props.code !== nextProps.code) {
      this.setState({ code: nextProps.code });
    }
  };

  setStdIn = val => {
    this.setState({ stdin: val });
  };

  setEditorCode = code => {
    this.setState({ code: code });
    setTimeout(() => {
      this.props.updateCode(this.props.currProblem.id, this.state.code);
    }, 0);
  };
  setSidePanelOpen = () => {
    this.setState(prevState => ({
      isSidePannelOpen: !prevState.isSidePannelOpen,
    }));
  };

  switchLanguage = language => {
    this.props.updateCode(this.props.currProblem.id, this.state.code);
    this.props.updateLang(language, this.props.currProblem.id);
  };

  onProblemClick = problem_id => {
    this.props.updateCode(this.props.currProblem.id, this.state.code);
    this.props.switchProblem(problem_id);
  };

  onSubmitSection = () => {
    switchToNextSection({
      sections: this.props.assessment.sections,
      currentSectionId: this.props.currentSectionId,
      history,
      assessmentId: this.state.assessment_id,
      endBy: TRIGGER_BY_USER,
    });
  };

  getSubmissionData = () => {
    let code_body_full = this.state.code;
    let data = {
      id: this.props.assessment.id,
      problem_id: this.props.currProblem.id,
      code_body: this.props.code,
      code_body_full: code_body_full,
      language: this.props.lang,
      cs_type: 'regular',
    };
    return data;
  };

  handleTestCode = () => {
    let data = this.getSubmissionData();
    data['cs_type'] = 'custom_input';
    data['ci_stdin'] = this.state.stdin;

    this.props.updateCode(data.problem_id, data.code_body_full);
    this.props.submitCode(data);
  };

  handleSubmitCode = () => {
    let data = this.getSubmissionData();
    this.props.updateCode(data.problem_id, data.code_body_full);
    this.setState({ editorExpand: false });
    this.props.submitCode(data);
    this.setState({ submit_disabled: true }, () => {
      setTimeout(() => {
        this.setState({ submit_disabled: false });
      }, 9000);
    });
  };

  handleTabSwitch = key => {
    this.TabHandler(key);
  };

  toggleExpand = () => {
    this.setState((prevState, props) => ({
      editorExpand: !prevState.editorExpand,
    }));
  };

  TabHandler = value => {
    let activeTab = '';
    switch (value) {
      case selectedTab.problemStatement:
        activeTab = selectedTab.problemStatement;
        break;
      case selectedTab.customInput:
        activeTab = selectedTab.customInput;
        break;
      case selectedTab.results:
        activeTab = selectedTab.results;
        break;
      default:
        activeTab = '';
    }
    this.props.chooseOption({
      activeTab: activeTab,
      problem_id: this.props.currProblem.id,
    });
  };

  handleBack = () => {
    history.push(`/assessment/${this.state.assessment_id}`);
  };

  isSubmitDisabled = () => {
    return (
      this.state.submit_disabled && this.props.testcases.filter(tc => tc.logo === 'LOAD').length > 0
    );
  };

  toggleTheme = checked => {
    if (checked) {
      this.setState({ theme: 'vs-dark' });
    } else {
      this.setState({ theme: 'vs-light' });
    }
  };

  toggleDriverCodeModal = () => {
    this.setState(prevState => ({
      showDriverCodeModal: !prevState.showDriverCodeModal,
    }));
  };

  render() {
    let problemSelectorSpan = this.state.isSidePannelOpen ? 3 : 1;
    let problemTabSpan = 11;
    let editorTabSpan = this.state.isSidePannelOpen ? 10 : 12;
    if (this.state.editorExpand) {
      problemSelectorSpan = this.state.isSidePannelOpen ? 3 : 1;
      problemTabSpan = 0;
      editorTabSpan = this.state.isSidePannelOpen ? 21 : 24;
    }

    // Tabs items for antd v5
    const tabItems = [
      {
        label: selectedTab.problemStatement,
        key: selectedTab.problemStatement,
        children: <ProblemDescription problem={this.props.currProblem} />,
      },
      {
        label: selectedTab.customInput,
        key: selectedTab.customInput,
        children: (
          <TestCase
            stdout={this.props.stdout}
            stderr={this.props.stderr}
            stdin={this.state.stdin}
            verdict={this.props.verdict}
            testcases={this.props.testcases}
            setInput={this.setStdIn}
            testCode={handleGAEvent(
              this.handleTestCode,
              GACategories.assessment,
              GAActions.testCode,
            )}
            isLoading={this.props.customInputLoading}
          />
        ),
      },
      {
        label: selectedTab.results,
        key: selectedTab.results,
        children: (
          <OutPut
            testcases={this.props.testcases}
            leftCount={this.props.totalProbs - this.props.attemptedCount}
            probStatus={this.props.currProblem.status}
          />
        ),
      },
    ];

    return (
      <div className={styles['l-problem-container']}>
        <Row
          gutter={16}
          className={styles['l-problem-container__row']}
        >
          <Col
            span={problemSelectorSpan}
            className={`${styles['problem-selector-col']} ${
              this.state.editorExpand && !this.state.isSidePannelOpen
                ? styles['problem-selector-col--expanded-hidden-panel']
                : ''
            }`}
          >
            {this.state.isSidePannelOpen ? (
              this.props.assessment.sections && this.props.assessment.sections.length > 0 ? (
                this.props.assessment.sections.map(section => {
                  const sectionProblems = this.props.sectionProblems[section.id] || [];
                  return (
                    <ProblemSidePanel
                      key={section.id}
                      style={{ padding: '0px', marginTop: '0px' }}
                      sectionHeading={section.title}
                      questionDetails={sectionProblems}
                      isSelected={section.id === this.props.currentSectionId}
                      setSidePanelOpen={this.setSidePanelOpen}
                      handleSidePanelClick={this.onProblemClick}
                      currentProblemId={this.props.currProblem.id}
                      sectionId={section.id}
                    />
                  );
                })
              ) : (
                <ProblemSidePanel
                  style={{ padding: '0px', marginTop: '0px', marginBottom: '10px' }}
                  sectionHeading="Coding Problems"
                  questionDetails={this.props.allProblems}
                  isSelected={this.state.isSidePannelOpen}
                  setSidePanelOpen={this.setSidePanelOpen}
                  handleSidePanelClick={this.onProblemClick}
                  currentProblemId={this.props.currProblem.id}
                />
              )
            ) : (
              <div
                className={styles['side-panel-mini']}
                onClick={this.setSidePanelOpen}
              >
                <RightOutlined />
              </div>
            )}
          </Col>
          <Col
            span={problemTabSpan}
            className={styles['problem-tab-col']}
          >
            <div className={styles['c-problem-def-results']}>
              <Tabs
                defaultActiveKey={selectedTab.problemStatement}
                activeKey={this.props.activeTab}
                tabBarExtraContent={
                  <span className={styles['points-span']}>
                    {this.props.currProblem.points} Points
                  </span>
                }
                onChange={handleGAEvent(
                  this.handleTabSwitch,
                  GACategories.assessment,
                  GAActions.switchTab,
                  (GALabels, argumentList) => {
                    return GALabels[argumentList[0]];
                  },
                )}
                items={tabItems}
              />
            </div>
          </Col>
          <Col
            span={editorTabSpan}
            className={`${styles['editor-col']} ${
              this.state.editorExpand ? styles['expanded-editor'] : ''
            } ${
              this.state.editorExpand
                ? this.state.isSidePannelOpen
                  ? styles['editor-col--expanded-open-panel']
                  : styles['editor-col--expanded-hidden-panel']
                : ''
            }`}
          >
            <Editor
              selectedLanguage={this.props.lang}
              editorExpand={this.state.editorExpand}
              languageList={this.props.languageList}
              switchLanguage={handleGAEvent(
                this.switchLanguage,
                GACategories.assessment,
                GAActions.changeLanguage,
                (GALabels, argumentList) => {
                  return GALabels[argumentList[0]];
                },
              )}
              toggleExpand={handleGAEvent(
                this.toggleExpand,
                GACategories.assessment,
                GAActions.toggleEditor,
              )}
              toggleTheme={handleGAEvent(
                this.toggleTheme,
                GACategories.assessment,
                GAActions.toggleTheme,
              )}
              lang={this.props.lang}
              code={this.state.code}
              updateCode={this.setEditorCode}
              activeTemplate={this.props.activeTemplate}
              headerSize={this.props.activeTemplate.header.split(/\r\n|\r|\n/).length - 1}
              footerSize={this.props.activeTemplate.tailer.split(/\r\n|\r|\n/).length}
              submitCode={handleGAEvent(
                this.handleSubmitCode,
                GACategories.assessment,
                GAActions.runCode,
              )}
              disabled={this.isSubmitDisabled()}
              disableCopyPaste={this.props.test_settings?.disable_copy_paste}
              theme={this.state.theme}
              onDriverCodeModalToggle={this.toggleDriverCodeModal}
            />
          </Col>
        </Row>
        {this.props.assessment.sections && this.props.assessment.sections.length > 0 ? (
          this.props.assessment.sections.map(section => {
            const sectionProblems = this.props.sectionProblems[section.id] || [];
            const currentIndex = sectionProblems.findIndex(p => p.id === this.props.currProblem.id);
            if (section.id === this.props.currentSectionId && currentIndex !== -1) {
              return (
                <ProblemNavigation
                  key={section.id}
                  currentProblemId={this.props.currProblem.id}
                  problems={sectionProblems}
                  onProblemClick={this.onProblemClick}
                  onSubmitSection={this.onSubmitSection}
                  isSaving={this.isSubmitDisabled()}
                  handleSidePanelClick={this.onProblemClick}
                />
              );
            }
            return null;
          })
        ) : (
          <ProblemNavigation
            currentProblemId={this.props.currProblem.id}
            problems={this.props.allProblems}
            onProblemClick={this.onProblemClick}
            onSubmitSection={this.onSubmitSection}
            isSaving={this.isSubmitDisabled()}
            handleSidePanelClick={this.onProblemClick}
          />
        )}
        <DriverCodeModal
          open={this.state.showDriverCodeModal}
          onCancel={this.toggleDriverCodeModal}
          lang={this.props.lang}
          activeTemplate={this.props.activeTemplate}
          theme={this.state.theme}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    assessment: state.assessment,
    currProblem: currProblemSelector(state.assessment),
    stdout: currProblemSelector(state.assessment).stdout,
    stderr: currProblemSelector(state.assessment).stderr,
    verdict: currProblemSelector(state.assessment).verdict,
    testcases: currProblemSelector(state.assessment).testcases,
    lang: currProblemSelector(state.assessment).editor.lang,
    code: currProblemSelector(state.assessment).editor.code[
      currProblemSelector(state.assessment).editor.lang
    ],
    activeTemplate: activeTemplateSelector(state.assessment),
    activeTab: activeTabSelector(state.assessment),
    allProblems: state.assessment.problems,
    sectionProblems: state.assessment.sectionProblems,
    currentSectionId: state.assessment.currentSectionId,
    languageList: languageListSelector(state.assessment),
    attemptedCount: attemptedCountSelector(state.assessment),
    totalProbs: state.assessment.problems.length,
    switchableSections: state.assessment.switchableSections,
    test_settings: state.assessment.test_settings,
    customInputLoading: state.assessment.customInputLoading,
    theme: state.events.theme,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetCustInpResults: () =>
      dispatch(
        actions.resetCustInpResults({
          stdout: null,
          stderr: null,
        }),
      ),
    chooseOption: val => dispatch(actions.chooseOption(val)),
    updateLang: (language, problem_id) =>
      dispatch(
        actions.updateLang({
          language: language,
          problem_id: problem_id,
        }),
      ),
    updateCode: (problem_id, code) =>
      dispatch(
        actions.updateCode({
          problem_id: problem_id,
          code: code,
        }),
      ),
    submitCode: data => dispatch(actions.submitCode(data)),
    fetchAssessment: (assessment_id, problem_id) =>
      dispatch(actions.fetchAssessment(assessment_id, problem_id)),
    switchProblem: problem_id => dispatch(actions.selectProblem(problem_id)),
    setCurrentPage: page_identifier => dispatch(actions.setCurrentPage(page_identifier)),
    setCurrentSectionId: section_id => dispatch(actions.setCurrentSectionId(section_id)),
    updateSectionStatus: (section_id, status) =>
      dispatch(actions.updateSectionStatus(section_id, status)),
    showModal: modalConfig => dispatch(showModal(modalConfig)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProblemContainer));
